export const CLOSE_NOTIFICATION = 'NOTIFICATION/CLOSE';
export const SHOW_NOTIFICATION = 'NOTIFICATION/SHOW';
